import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AutomaticDebitService } from '../../services/automatic-debit.service';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import { CustomResponseData } from 'src/app/interfaces/CustomResponse';
import { FileService } from 'src/app/services/file.service';
import { NotificationsService } from 'angular2-notifications';
import { AutomaticDebitRemFile, FilePaginatorRem } from '../../models/automaticDebitRemFile';
import { FileType } from '../../models/inputModels';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticDebitSelectDialogComponent } from '../automatic-debit-select-dialog/automatic-debit-select-dialog.component';

@Component({
    selector: 'automatic-debit-files',
    templateUrl: './automatic-debit-files.component.html',
    styleUrls: ['./automatic-debit-files.component.scss'],
})
export class AutomaticDebitFilesComponent implements OnInit {
    constructor(
        private automaticDebitService: AutomaticDebitService,
        private sessionBusiness: SessionBusiness,
        private _cdRef: ChangeDetectorRef,
        private fileService: FileService,
        private notificationsService: NotificationsService,
        public dialog: MatDialog,
    ) {}
    fileListPaginated: AutomaticDebitRemFile[] = [];
    loading: boolean = false;
    collectionSize: number = 0;
    page: number = 1;
    pageSize: number = 10;

    ngOnInit(): void {
        this.loadPaginator();
    }

    openModal(file: AutomaticDebitRemFile): void {
        const dialogRef = this.dialog.open(AutomaticDebitSelectDialogComponent, {
            width: '900px',
            data: { file: file },
        });
        this._cdRef.detectChanges();
        console.log(file);
        dialogRef.afterClosed().subscribe((result) => {
            console.log('The dialog was closed');
        });
    }

    downloadFile(file: AutomaticDebitRemFile) {
        this.showLoad(true);
        this.automaticDebitService.DownloadFile(file.id, FileType.Rem).subscribe(
            (response) => {
                this.fileService.downloadFile(response);
                this.notificationsService.success(`Download completo!`);
                this.showLoad(false);
            },
            (error) => {
                console.error('Erro', error);
                this.showLoad(false);
            },
        );
    }

    showLoad(value: boolean) {
        this.loading = value;
        this._cdRef.detectChanges();
    }

    loadPaginator() {
        let legalEntityId = this.sessionBusiness.LegalEntityIdContext;
        let skip = (this.page - 1) * this.pageSize;
        let take = this.pageSize;

        this.showLoad(true);
        this.automaticDebitService
            .GetFilesRm(legalEntityId, skip, take)
            .subscribe((result: CustomResponseData<FilePaginatorRem>) => {
                if (result && result.success) {
                    this.fileListPaginated = result.data.result;
                    this.collectionSize = result.data.totalRecords;
                }
                this.showLoad(false);
                this._cdRef.detectChanges();
            });
    }
}
